<template>
  <b-row>
    <b-col class="text-center">
      <b-button variant="primary" @click="addRow">
        <i class="fas fa-plus"></i>
        <span>Insert Row</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  methods: {
    addRow() {
      this.$store.commit('items/addItem', {type: 'row'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/items/empty-topic.vue